import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  BreederRelatedLinksGetArticlesQuery,
  BreederRelatedLinksGetArticlesQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDER_RELATED_LINK_GET_ARTICLES = graphql(`
  query BreederRelatedLinksGetArticles(
    $take: Int
    $where: ArticleWhereInput
    $translationsWhere: ArticleTranslationsWhereInput
  ) {
    findManyArticle(where: $where, take: $take, randomOrder: true) {
      id
      translations(where: $translationsWhere) {
        id
        url
        title
      }
    }
  }
`);

export const useGetArticles = () => {
  const { languageCode } = useRouter();

  const variables = useMemo((): BreederRelatedLinksGetArticlesQueryVariables => {
    return {
      take: 10,
      translationsWhere: { languageCode: { equals: languageCode } },
      where: {
        AND: [
          {
            translations: {
              some: {
                AND: [
                  { languageCode: { equals: languageCode }, active: { equals: true } },
                  { url: { not: { equals: '' } } },
                  { url: { not: { equals: undefined } } },
                  { title: { not: { equals: '' } } },
                  { title: { not: { equals: undefined } } },
                ],
              },
            },
          },
          { published: { equals: true } },
        ],
      },
    };
  }, [languageCode]);

  const { data, error, loading } = useQuery<
    BreederRelatedLinksGetArticlesQuery,
    BreederRelatedLinksGetArticlesQueryVariables
  >(BREEDER_RELATED_LINK_GET_ARTICLES, { variables, ssr: false });

  return {
    articles: data?.findManyArticle,
    articlesError: error,
    articlesLoading: loading,
  };
};
